import {inject} from "@angular/core";
import {GtmAbstractService} from '../services/gtm.abstract.service';
import {GtmDummyService} from '../services/gtm.dummy.service';
import {GtmService} from '../services/gtm.service';

// TODO: this config change should not be done at inject level, but at provide level (override the value of an injection token)
export function injectGtmService(gtmConfig: any): GtmAbstractService {
	if (gtmConfig) {
		return inject(GtmService);
	} else {
		return inject(GtmDummyService);
	}
}